import { render, staticRenderFns } from "./sales-item-table.vue?vue&type=template&id=c1e59dfa&scoped=true&"
import script from "./sales-item-table.vue?vue&type=script&lang=js&"
export * from "./sales-item-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e59dfa",
  null
  
)

export default component.exports